import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ExportScheduleModal from 'modules/shift_management/components/ShiftManagement/ExportScheduleModal'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

const ExportScheduleComponent = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [{ view }] = useSchedule()

  return (
    <ResponsivePage.Body>
      <ExportScheduleModal
        onClose={() =>
          navigate(
            navigation.shifts.customViewGroup.fullPath({
              viewType: view.viewType,
              groupType: view.groupType,
              year: view.startRangeYear,
              month: view.startRangeMonth,
              day: view.startRangeDay,
            })
          )
        }
      />
    </ResponsivePage.Body>
  )
}

const ExportSchedule = observer(ExportScheduleComponent)

export default ExportSchedule
